import cn from 'classnames';

import FeatureTitle from 'react-scale/components/pages/customers/FeatureTitle';

const CustomerSection = ({
  id,
  overtitle,
  title,
  text,
  video,
  image,
  lidar,
  caption,
  paddingBottom,
  paddingTop,
  info,
  border
}) => (
  <section
    id={id}
    className={cn('py-20', {
      'pb-0 lg:pb-0': !paddingBottom,
      'pt-0 lg:pt-0': !paddingTop,
      'pt-10': !border && paddingTop
    })}
  >
    <div
      className={cn('container justify-between pt-16 lg:flex ', {
        'border-t border-neutral-200': border
      })}
    >
      <FeatureTitle
        overtitle={overtitle}
        title={title}
        subtitle={text}
        video={video}
        image={image}
        lidar={lidar}
        caption={caption}
        info={info}
      />
    </div>
  </section>
);

export default CustomerSection;
